import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Hash.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
a.displayName = "HashIcon";
const n = a;
export {
  n as Hash,
  a as HashIcon
};
